import { ModalAlterarPrecoAtacadoPropsSchemaProps } from '../../../../../components/ModalAlterarPrecoAtacado/ModalAlterarPrecoAtacado';
import { PrecoAtacadoPaginationState } from '../../../../../reducers/PrecoAtacado/pagination';
import { PrecoAtacadoSelectedDatapointsState } from '../../../../../reducers/PrecoAtacado/selectedDatapoints';
import { PrecoAtacadoSortState } from '../../../../../reducers/PrecoAtacado/sort';
import { convertClusterParams } from '../../../../../utils/convertClusterParams';
import { getValidData } from '../../../RevisaoPrecos/utils';
import { GET_ITEMS_PRECO_ATACADO_PARAMS, POST_CHANGE_MASSIVE_PRICE_DATA, POST_CLEAR_MASSIVE_FIELDS_DATA } from './services';

type WholesaleFilters = Partial<Record<string, string[]>>;

/**
 * Os endpoints em massa precisam descrever a mesma população que a tabela
 * carregou. O GET de /wholesale-price/products descarta filtro com lista vazia
 * e envia clusterIds; sem a mesma normalização, "selecionar tudo" alcança
 * linhas que nunca estiveram na tela.
 */
const GET_WHOLESALE_BULK_FILTERS = (filters: WholesaleFilters): WholesaleFilters => {
  return convertClusterParams(getValidData(filters));
};

export namespace PrecoAtacadoChangeMassivePrice {
  export type Params = {
    formData: ModalAlterarPrecoAtacadoPropsSchemaProps;
    selectedDatapoints: PrecoAtacadoSelectedDatapointsState;
    filters: Partial<Record<string, string[]>>;
  };
  export type Return = POST_CHANGE_MASSIVE_PRICE_DATA;
}

export const GET_CHANGE_MASSIVE_PRICE_MODEL = ({
  formData,
  selectedDatapoints,
  filters,
}: PrecoAtacadoChangeMassivePrice.Params): PrecoAtacadoChangeMassivePrice.Return => {
  const { excludedIds, selectedIds, selectedAll } = selectedDatapoints;
  return {
    ...formData,
    selectedAll,
    filters: GET_WHOLESALE_BULK_FILTERS(filters),
    products: {
      excludedIds,
      selectedIds,
    },
  };
};

namespace GetPrecoAtacadoDatapoints {
  export type Params = {
    sort: PrecoAtacadoSortState;
    pagination: PrecoAtacadoPaginationState;
    filters: Partial<Record<string, string[]>>;
  };
  export type Return = GET_ITEMS_PRECO_ATACADO_PARAMS;
}

export const GET_PRECO_ATACADO_DATAPOINTS_MODEL = (params: GetPrecoAtacadoDatapoints.Params): GetPrecoAtacadoDatapoints.Return => {
  const { sort, pagination, filters } = params;

  return {
    filters,
    page: pagination.activePage,
    size: pagination.displayLength,
    sort: `${sort.type},${sort.orderBy}`,
  };
};

export namespace PrecoAtacadoClearMassiveFields {
  export type Params = {
    selectedDatapoints: PrecoAtacadoSelectedDatapointsState;
    filters: Partial<Record<string, string[]>>;
  };
  export type Return = POST_CLEAR_MASSIVE_FIELDS_DATA;
}

export const GET_CLEAR_MASSIVE_FIELDS_MODEL = ({
  selectedDatapoints,
  filters,
}: PrecoAtacadoClearMassiveFields.Params): PrecoAtacadoClearMassiveFields.Return => {
  const { excludedIds, selectedIds, selectedAll } = selectedDatapoints;

  return {
    selectedAll,
    filters: GET_WHOLESALE_BULK_FILTERS(filters),
    products: {
      excludedIds,
      selectedIds,
    },
  };
};
